import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SIMPLModal } from '../dialog/SIMPLModal';
import { SIMPLButtonCustomized } from '../button/SIMPLButtonCustumized';
import { SIMPLInputTextCustumized } from '../input/SIMPLInputTextCustumized';

interface GenerateCredentialLinkModalProps {
  onCancel: () => void;
  onGenerate: () => void;
}

export const GenerateCredentialLinkModal: React.FC<GenerateCredentialLinkModalProps> = ({
  onCancel,
  onGenerate,
}) => {
  const { t } = useTranslation();
  const [credentialInput, setCredentialInput] = useState<string>('');
  const [hasError, setHasError] = useState<boolean>(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setCredentialInput(e.target.value);
    setHasError(false);
  };

  const handleGenerate = () => {
    if (!credentialInput.trim()) {
      setHasError(true);
      return;
    }
    onGenerate();
  };

  const actions = (
    <div className="flex items-center gap-3 -mr-4">
      <SIMPLButtonCustomized
        label={t('Cancel')}
        secondary
        buttonHandlerAction={onCancel}
        testId="generate-credential-link-cancel"
      />
      <SIMPLButtonCustomized
        label={t('Generate')}
        primary
        buttonHandlerAction={handleGenerate}
        testId="generate-credential-link-submit"
      />
    </div>
  );

  return (
    <SIMPLModal
      title={t('GenerateCredentialsLink')}
      onClose={onCancel}
      actions={actions}
      testId="generate-credential-link-modal"
    >
      <SIMPLInputTextCustumized
        id="generate-credential-link-input"
        name="credentialInput"
        type="textarea"
        value={credentialInput}
        onChange={handleChange}
        placeholder={t('AddTextHere')}
        rows={5}
        errorLabel={hasError ? t('CredentialLinkInputRequired') : undefined}
        hideLabel
        testId="generate-credential-link-input"
      />
      {hasError && (
        <p
          className="mt-1 text-sm text-error"
          data-test-id="generate-credential-link-error"
        >
          {t('CredentialLinkInputRequired')}
        </p>
      )}
    </SIMPLModal>
  );
};
